import * as React from 'react';
import { ArticleParagraph2, Image } from '@cian/ui-kit';
import { Faq16 } from '@cian/ui-kit/prev';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../../../constants/mediaQueries';

import * as styles from './styles.css';

export const DealStepModalCard: React.FC<{
  children: string | string[];
  imageX1: string;
  imageX2: string;
  onClick?(): void;
}> = props => {
  const isClickable = !!props.onClick;

  return (
    <li className={styles['container']}>
      <button
        type="button"
        title="Узнать больше"
        data-testid="deal-step-modal-card-button"
        className={styles['card']}
        disabled={!isClickable}
        onClick={props.onClick}
      >
        <Image
          width={128}
          height={60}
          loading="lazy"
          src={props.imageX1}
          sources={[{ srcset: props.imageX2, media: X2_IMAGE_SIZE_MEDIA_QUERY }, { srcset: props.imageX1 }]}
        />
        <ArticleParagraph2>{props.children}</ArticleParagraph2>
        {isClickable && (
          <div className={styles['hint']}>
            <Faq16 />
          </div>
        )}
      </button>
    </li>
  );
};
